module.exports = __webpack_public_path__ + "assets/img/de.c6e4789c.png";